import React from "react";
import {Button, Card, Typography} from "antd";
import PropTypes from "prop-types";

import "../assets/less/Card.less";

const ListCard = ({id, image, imageAltText, imageDescription, title, description, onClick, buttonText}) => {
    return (
        <Card
            onClick={() => onClick(id)}
            className="list-card"
            cover={
                image &&
                <>
                    <img alt={imageAltText} src={image} className="list-card-img-container"/>
                    {
                        imageDescription && <Typography.Text>{imageDescription}</Typography.Text>
                    }
                </>
            }
        >
            <Card.Meta
                title={
                    <Typography.Text strong ellipsis>
                        {title}
                    </Typography.Text>
                }
                description={
                    <span>
                      <Typography.Paragraph ellipsis={{rows: 2}} className="long-text-wrap">
                          {description}
                      </Typography.Paragraph>
                      <Button
                          type="primary"
                          onClick={() => onClick(id)}>
                        {buttonText}
                      </Button>
                </span>
                }
            />
        </Card>
    )
};

export default ListCard;

ListCard.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    image: PropTypes.node,
    imageAltText: PropTypes.string,
    imageDescription: PropTypes.string,
}
